<template>
  <div class="asign-dialog-box">

    <el-dialog

      :title="$t('wrh-dashboard.asign-dialog-box.title')"
      @close="onClose"
      visible>

      <div class="mx-24 my-16 el-text el-text--size-xs">
        <div>
          {{ $t('wrh-dashboard.asign-dialog-box.message') }}
        </div>
      </div>

      <template #footer>
        <el-button
          @click="onClose"
          native-type="button"
          type="secondary">
          {{ $t('wrh-dashboard.form.button.cancel') }}
        </el-button>
        <el-button
          v-if="!isCompleted"
          native-type="button"
          @click="onContinue"
          :loading="isInProgress"
          :disabled="isInProgress"
        >
          {{ $t('wrh-dashboard.form.button.proceed') }}
        </el-button>
        <el-button
          v-if="isCompleted"
          native-type="button"
          @click="onShowFileDetails"
        >
          {{ $t('wrh-dashboard.asign-dialog-box.button.show-signed-file-details') }}
        </el-button>
      </template>
    </el-dialog>

  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';

import {
  SIGN_FILE,
  RESET_SIGN_FILE_STATUS
} from '../store/action-types';

import {
  PENDING_STATUS,
  COMPLETED_STATUS
} from '../store/action-status';

const { mapGetters, mapActions } = createNamespacedHelpers('wrh-dashboard');

export default {
  name: 'ASignDialogBox',
  props: {
    archiveId: {
      type: String,
      default: '',
      required: true
    },
    fileName: {
      type: String,
      default: '',
      required: true
    },
    path: {
      type: String,
      default: '',
      required: true
    },
    fileVersion: {
      type: Number,
      default: 0,
      required: false
    }
  },
  data() {
    return {
    };
  },
  computed: {
    ...mapGetters([
      'getSignFileStatus',
      'getSignFileLink'
    ]),
    isCompleted() {
      return this.getSignFileStatus === COMPLETED_STATUS;
    },
    isInProgress() {
      return this.getSignFileStatus === PENDING_STATUS;
    }
  },
  methods: {
    ...mapActions({
      signFile: SIGN_FILE,
      resetSignFileStatus: RESET_SIGN_FILE_STATUS
    }),
    onContinue() {
      this.signFile({
        archiveId: this.archiveId,
        path: this.path,
        fileVersion: this.fileVersion
      });
    },
    onShowFileDetails() {
      window.open(this.getSignFileLink, '_blank');
      this.onClose();
    },
    onClose() {
      this.resetSignFileStatus();
      this.$emit('handleClose');
    }
  }
};
</script>

<style lang="scss" scoped>

</style>
